import { useQuery } from "@tanstack/react-query";
import { useAuth } from "#/hooks/use-auth";
import { queryKeys } from "#/hooks/query-keys";
import { fetchMyWithdrawals } from "#/lib/api/referrals";

/**
 * Polls the withdrawals history every 10s when there's an inflight row
 * (pending/sent) so the user sees status transitions without a refresh.
 * Goes idle once all rows have terminated (confirmed/failed).
 */
export function useMyWithdrawals() {
	const { isAuthenticated, userId } = useAuth();

	return useQuery({
		queryKey: queryKeys.referrals.myWithdrawals(userId),
		queryFn: fetchMyWithdrawals,
		enabled: isAuthenticated,
		staleTime: 5_000,
		refetchInterval: (query) => {
			const data = query.state.data;
			if (!data) return false;
			const inflight = data.withdrawals.some(
				(w) => w.status === "pending" || w.status === "sent",
			);
			return inflight ? 10_000 : false;
		},
	});
}
